import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RevealDirective } from '../../core/directives/reveal.directive';

@Component({
  selector: 'hx-program-cards',
  standalone: true,
  imports: [MatCardModule, RevealDirective],
  template: `
    <section class="section-tight">
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">Reward programs</p>
          <h2>Two ways you earn.</h2>
          <p>
            Which one applies depends on the kind of project the business you refer needs. Our team
            figures out which fits — you don't have to.
          </p>
        </div>

        <div class="grid-2">
          <!-- Program 1 -->
          <div class="reveal" appReveal>
            <mat-card
              appearance="outlined"
              style="
                border: 1px solid #eef2f7;
                border-radius: 28px;
                background: #fff;
                box-shadow: 0 20px 50px rgba(15, 23, 42, 0.05);
              "
            >
              <mat-card-content
                style="
                  padding: 36px;
                  display: flex;
                  flex-direction: column;
                  height: 100%;
                "
              >
                <span
                  class="program-badge"
                  style="
                    align-self: flex-start;
                    margin-bottom: 30px;
                  "
                >
                  For complex, custom-built projects
                </span>

                <div class="program-figure">
                  <b style="color:#3346d3;">Up to 30%</b>
                  <span>of the total project cost</span>
                </div>

                <h3 style="margin:34px 0 18px;">
                  "We Earn, You Earn" Program
                </h3>

                <p class="program-desc">
                  For bigger, one-of-a-kind builds — think banking systems,
                  government portals, or custom platforms — you can earn up to
                  30% of everything the client pays us.
                </p>

                <hr/>

                <div class="program-detail">
                  <span class="program-detail-label">
                    How you're paid
                  </span>

                  <p style="margin:12px 0 0; line-height:1.8;">
                    In stages, matching the client's own payment schedule —
                    a share of every payment they make to us, starting with
                    their first and continuing through to their last.
                  </p>
                </div>

                <div
                  class="program-example"
                  style="
                    margin-top:32px;
                    padding:24px;
                    border-radius:18px;
                    background:#f7f8fc;
                    border:none;
                  "
                >
                  <span>Example</span>

                  <p style="margin-top:12px; line-height:1.8;">
                    Project is worth <b>₱2,000,000</b> in total →
                    your commission can be up to
                    <b>₱600,000</b>, released a little at a time
                    as the client pays us.
                  </p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Program 2 -->
          <div class="reveal" appReveal>
            <mat-card
              appearance="outlined"
              style="
                border: 1px solid rgba(34, 197, 94, .18);
                border-radius: 28px;
                background:
                  radial-gradient(circle at top right, rgba(34,197,94,.14), transparent 35%),
                  linear-gradient(180deg,#fbfffc 0%,#effcf4 100%);
                box-shadow: 0 20px 50px rgba(15,23,42,.05);
              "
            >
              <mat-card-content
                style="
                  padding:36px;
                  display:flex;
                  flex-direction:column;
                  height:100%;
                "
              >
                <span
                  class="program-badge program-badge-alt"
                  style="
                    align-self:flex-start;
                    margin-bottom:30px;
                  "
                >
                  For hosted &amp; subscription projects
                </span>

                <div class="program-figure">
                  <b style="color:#059669;">Up to 100%</b>
                  <span>of the project build cost</span>
                </div>

                <h3 style="margin:34px 0 18px;">
                  "You Earn, We're Discovered" Program
                </h3>

                <p class="program-desc">
                  For projects that come with ongoing hosting or a monthly plan,
                  we can give you up to 100% of what we charge just to build it.
                </p>

                <hr style="border: 0; border-top: 1px solid #059669;">

                <div class="program-detail">
                  <span class="program-detail-label">
                    How you're paid
                  </span>

                  <p style="margin:12px 0 0; line-height:1.8;">
                    In one payment — released after the project is deployed and
                    the client has officially accepted it. No staging, no
                    waiting for multiple milestones.
                  </p>
                </div>

                <div
                  class="program-example"
                  style="
                    margin-top:32px;
                    padding:24px;
                    border-radius:18px;
                    background:rgba(255,255,255,.78);
                    border:1px solid rgba(34,197,94,.12);
                    backdrop-filter:blur(10px);
                  "
                >
                  <span>Why we do this</span>

                  <p style="margin-top:12px; line-height:1.8;">
                    We call this our <b>Discovery Program</b>. For these
                    projects, meeting new clients and building long-term
                    relationships matters more to us than the upfront build fee
                    — so more of it goes to you.
                  </p>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </section>
  `,
})
export class ProgramCardsComponent {}
